import { useEffect } from 'react';

/**
 * Custom hook to listen for navigation events from the main nav.
 *
 * @param {Function} handleNavClick - Callback function to handle navigation clicks.
 */
function useEspotNavigationListener(handleNavClick) {
  useEffect(() => {
    const navigationEspotLists = document.querySelectorAll('div.aem-category-list-component');
    navigationEspotLists.forEach((list) => {
      list.addEventListener('click', handleNavClick);
    });
    window.addEventListener('mfe:categoryId', handleNavClick);
    return () => {
      window.removeEventListener('mfe:categoryId', handleNavClick);
      navigationEspotLists.forEach((list) => {
        list.removeEventListener('click', handleNavClick);
      });
    };
  }, [handleNavClick]);
}

export default useEspotNavigationListener;
